var React = require('react');

function Submit (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M176 176v-40a40 40 0 0140-40h208a40 40 0 0140 40v240a40 40 0 01-40 40H216a40 40 0 01-40-40v-40","fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","key":0}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M272 336l80-80-80-80M48 256h288","key":1})]);
}

Submit.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Submit;

Submit.default = Submit;
